// pages/AdminDashboard.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

const AdminDashboard = () => {
  const navigate = useNavigate();
  const sections = [
    { title: "Users", description: "Manage all registered users", color: "bg-blue-500", path: "/adminallusers" },
    { title: "Orders", description: "View and track all orders", color: "bg-green-500", path: "/adminorders" },
    { title: "Payments", description: "Monitor transactions & balances", color: "bg-yellow-500", path: "/adminpayment" },
    { title: "Notification", description: "Configure system Notification", color: "bg-red-500", path: "/adminnotification" },
    { title: "Messages", description: "View and manage all messages", color: "bg-purple-500", path: "/adminmessages" }, // ✅ New section
 { title: "Rider", description: "View and manage all riders", color: "bg-yellow-500", path: "/adminrider" }, // ✅ New section
 
  ];

  return (
    <div className="min-h-screen bg-gray-100 px-6 py-8">
      <h1 className="text-3xl font-bold text-gray-800 mb-8 text-center">
        Admin Dashboard
      </h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
        {sections.map((section, idx) => (
          <div
            key={idx}
            onClick={() => navigate(section.path)}
            className={`${section.color} text-white rounded-xl shadow-lg p-6 flex flex-col items-center justify-center cursor-pointer hover:scale-105 transition-transform`}
          >
            <h2 className="text-xl font-semibold mb-2">{section.title}</h2>
            <p className="text-sm opacity-90 text-center">{section.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminDashboard;
